import { lazy } from 'react';
export const DayList = lazy(() => import('./DayList'));
